import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tableTrFn = /* @__PURE__ */ createRecipe('table-tr', {}, [])

const tableTrVariantMap = {}

const tableTrVariantKeys = Object.keys(tableTrVariantMap)

export const tableTr = /* @__PURE__ */ Object.assign(memo(tableTrFn.recipeFn), {
  __recipe__: true,
  __name__: 'tableTr',
  __getCompoundVariantCss__: tableTrFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tableTrVariantKeys,
  variantMap: tableTrVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tableTrVariantKeys)
  },
  getVariantProps: tableTrFn.getVariantProps,
})